import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-nav',
  templateUrl: './custom-nav.component.html',
  styleUrls: ['./custom-nav.component.scss']
})
export class CustomNavComponent implements OnInit {
  @Input() sticky = false;
  
  constructor() { }

  ngOnInit(): void {
  }

}
